import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const BeaconAlert = ({ urlValid, gdprCompliant }) => (
  <Fragment>
    {urlValid === false ? <UrlError /> : null}
    {gdprCompliant === false ? <GdprError /> : null}
  </Fragment>
);

BeaconAlert.propTypes = {
  urlValid: PropTypes.bool,
  gdprCompliant: PropTypes.bool
};

BeaconAlert.defaultProps = {
  urlValid: undefined,
  gdprCompliant: undefined
};

const UrlError = () => (
  <div>
    <small className="error">
      We were unable to validate this URL. Please ensure that it is correct.
    </small>
  </div>
);

const GdprError = () => (
  <div>
    <small className="error">
      This tracker is not associated with an approved GDPR vendor. If you
      believe you have received this message in error, please contact your
      Sharethrough representative.
    </small>
  </div>
);

export default BeaconAlert;
